// Definición de defaults

export const defaultFormaNotificacion: FormaNotificacionProps = {
    idFormaNotificacion:   0,
    descripcion:           '',
    activo:                false,
}

// Creación de interfaces

export interface FormaNotificacionProps {
    idFormaNotificacion:        number;
    descripcion:             string;
    activo:                  boolean;
}